<template>
  <div class="banner">
    <p class="title"></p>
    <div class="compareBox">
      <div class="soilBox soilOne">
        <img
          :src="
            choseComponent01 === 0
              ? require('../assets/img/forecast/Component2-2.png')
              : choseComponent01 === true
              ? require('../assets/img/forecast/Component2-1.png')
              : require('../assets/img/forecast/Component2-2.png')
          "
          alt=""
          class="choseBtn choseBtn01"
          @click="choseBtn01(true)"
        />
        <img
          :src="
            choseComponent01 === 0
              ? require('../assets/img/forecast/Component1-2.png')
              : choseComponent01 === false
              ? require('../assets/img/forecast/Component1-1.png')
              : require('../assets/img/forecast/Component1-2.png')
          "
          alt=""
          class="choseBtn choseBtn02"
          @click="choseBtn01(false)"
        />
      </div>
      <div class="soilBox soilTwo">
        <img
          :src="
            choseComponent02 === 0
              ? require('../assets/img/forecast/Component2-2.png')
              : choseComponent02 === true
              ? require('../assets/img/forecast/Component2-1.png')
              : require('../assets/img/forecast/Component2-2.png')
          "
          alt=""
          class="choseBtn choseBtn03"
          @click="choseBtn02(true)"
        />
        <img
          :src="
            choseComponent02 === 0
              ? require('../assets/img/forecast/Component1-2.png')
              : choseComponent02 === false
              ? require('../assets/img/forecast/Component1-1.png')
              : require('../assets/img/forecast/Component1-2.png')
          "
          alt=""
          class="choseBtn choseBtn04"
          @click="choseBtn02(false)"
        />
      </div>
    </div>
    <img :src="sumbitImg" alt="" class="nextBtn" @click="sumbitBtn" @mouseenter="submitBtnActive" @mouseleave="submitBtn" />
    <img src="../assets/img/home.png" class="homeBtn" @click="homeBack" />
    <audio ref="audioPlay" :loop="false">
      <source :src="oneAudio" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlayFour" :loop="false">
      <source :src="fourAudio" type="audio/mpeg" />
    </audio>
  </div>
</template>
<script setup>
import anime from "animejs";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import oneAudio from "../assets/audio/compare/oneAudio.mp3";
import fourAudio from "../assets/audio/reason/fourAudio.mp3";

let audioPlay = ref();
let audioPlayFour = ref();

import sumbitBtnImg from "../assets/img/forecast/submitBtn.png";
import sumbitBtnActiveImg from "../assets/img/forecast/submitBtnActive.png";
import { ElMessage } from "element-plus";

// 高亮切换
let sumbitImg = ref(sumbitBtnImg);
// 首页按钮切换
const submitBtnActive = () => {
  sumbitImg.value = sumbitBtnActiveImg;
};
const submitBtn = () => {
  sumbitImg.value = sumbitBtnImg;
};

// 模组定义
const router = useRouter(0);
// 土壤数值
let soilValue01 = ref(0);
let soilValue02 = ref(0);

// 记录数据
let choseComponent01 = ref(0);
let choseComponent02 = ref(0);

// 选择数据
const choseBtn01 = (value) => {
  choseComponent01.value = value;
};
const choseBtn02 = (value) => {
  choseComponent02.value = value;
};

const sumbitBtn = () => {
  if (choseComponent01.value === 0 || choseComponent02.value === 0) {
    ElMessage.closeAll();
    ElMessage.warning("請進行選擇！再繼續！");
    return;
  }
  if (choseComponent01.value === false || choseComponent02.value === true) {
    audioPlayFour.value.play();
    return;
  }
  router.push({ name: "reasonPage" });
};

const homeBack = () => {
  router.push({ name: "home" });
};

onMounted(async () => {
  soilValue01.value = localStorage.getItem("soilValue").split(",")[0];
  soilValue02.value = localStorage.getItem("soilValue").split(",")[1];
  await audioPlay.value.play();
});
</script>
<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-image: url(../assets/img/component/background.png);
  overflow: hidden;
  .title {
    width: 100%;
    position: absolute;
    top: 5vh;
    font-size: 2.7vw;
    color: #fff;
    text-align: center;
  }
  .compareBox {
    width: 75vw;
    position: absolute;
    top: 28vh;
    left: 13.5vw;
    display: flex;
    justify-content: space-between;
    .soilBox {
      position: relative;
      width: 31vw;
      height: 52vh;
      background-size: 100% 100%;
      .choseBtn {
        width: 6vw;
        height: 6vh;
        position: absolute;
      }
      .choseBtn01 {
        top: 41vh;
        left: 16.5vw;
      }
      .choseBtn02 {
        top: 41.2vh;
        left: 22vw;
      }
      .choseBtn03 {
        top: 40.7vh;
        left: 17vw;
      }
      .choseBtn04 {
        top: 40.9vh;
        left: 22.2vw;
      }
    }
    .soilOne {
      background-image: url(../assets/img/component/soil01.png);
    }
    .soilTwo {
      background-image: url(../assets/img/component/soil02.png);
    }
    .soilValue {
      font-size: 2.4vw;
      color: #fff;
      width: 10.6vw;
      text-align: center;
      margin-top: 8.5vh;
      margin-left: 1vw;
    }
    .weightValue {
      font-size: 2.4vw;
      color: #fff;
      width: 10.6vw;
      text-align: center;
      margin-top: 37vh;
      margin-left: 1vw;
    }
  }
  .reasonBox {
    width: 46vw;
    height: 64vh;
    background-image: url(../assets/img/component/reasonBox.png);
    background-size: 100% 100%;
    position: absolute;
    top: 18vh;
    right: -41vw;
    .reasonContent {
      position: absolute;
      top: 6.5vh;
      left: 6.6vw;
      width: 38vw;
      height: 54vh;
      display: flex;
      padding-top: 30.5vh;
      padding-left: 7.5vw;
      box-sizing: border-box;
      background-size: 100% 100%;
      background-image: url(../assets/img/forecast/forecListBackground.png);
      .rankValue {
        width: 7.9vw;
        left: 17.5vw;
        top: 36vh;
        text-align: center;
        font-size: 2vw;
        color: #fff;
      }
      .rankValue01 {
        margin-left: 3.3vw;
      }
      .rankValue02 {
        margin-left: 0.8vw;
      }
    }
  }
  .nextBtn {
    position: absolute;
    bottom: 6.7vh;
    right: 41vw;
    width: 20vw;
    box-sizing: border-box;
    text-align: center;
  }
  .homeBtn {
    position: absolute;
    bottom: 2vh;
    right: 2vw;
    width: 5vw;
  }
}
</style>
